module.exports = __webpack_public_path__ + "static/media/bnp_food.dcd06431.svg";